import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { Colors } from '@zapier/design-system';
import { ArticleImage } from 'components/Images/ArticleImage/ArticleImage';
import { ArticleRichImage } from 'data/SingleArticle/types';
import { ImageQueryParams } from 'components/Images/RichImageComponent/RichImageComponent';

type Props = {
  image: ArticleRichImage;
  children: ReactNode;
};

const imageBlockQueryParams: Readonly<ImageQueryParams> = {
  w: '700',
};

export const ImageBlock = ({ children, image }: Props) => {
  return (
    <Outer>
      <Image image={image} queryParams={imageBlockQueryParams} />
      <Caption>{children}</Caption>
    </Outer>
  );
};

const Outer = styled.div`
  display: grid;
`;

const Image = styled(ArticleImage)`
  border: 1px solid ${Colors.grey200};
  border-radius: 5px;
  height: auto;
  width: 100%;
`;

const Caption = styled.figcaption`
  color: ${Colors.grey700};
  > small {
    font-size: 11px;
  }
  line-height: 130%;
  margin-top: 10px;
`;
